import { useEffect } from "react";
import { ArrowLeft, RouteOff } from "lucide-react";

export function NotFoundPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "404｜陈沐彬";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <main className="not-found-page">
      <div className="contact-grid" aria-hidden="true" />
      <RouteOff className="not-found-icon" aria-hidden="true" />
      <h1>404</h1>
      <p className="not-found-copy">页面不存在，这条质量路径没有对应的目标。</p>
      <a href="/" className="resume-button" aria-label="返回首页">
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        返回首页
      </a>
    </main>
  );
}
